import { useSelector } from 'react-redux';
import { Toast } from './toast';
import { css } from 'linaria';
const toastStyle = "t1qdyznf";
export const Toasts = () => {
  const toasts = useSelector(state => state.toasts);
  return <div className={toastStyle}>
      {toasts.map(toast => <Toast {...toast} key={toast.stamp} />)}
    </div>;
};

require("./toast-list.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./toast-list.js");